import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { registerServiceWorker, applyUpdate, unregisterServiceWorker } from "@/lib/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "production") {
  registerServiceWorker((reg) => {
    toast("COMMITMENTT has been updated", {
      description: "A new version is available.",
      duration: Infinity,
      action: { label: "Update", onClick: () => applyUpdate(reg) },
    });
  });
} else {
  unregisterServiceWorker();
}

window.addEventListener("offline", () => {
  toast.error("You're offline", { id: "offline", description: "COMMITMENTT needs an internet connection to update your latest financial information.", duration: Infinity });
});
window.addEventListener("online", () => { toast.dismiss("offline"); toast.success("Back online"); });
